import React from 'react';
import { bootstrap } from '@framework/app';
import { useCountDown } from 'ahooks-v2';
import './bbsTip.less';
import PageJump from '@util/pageJump';
import PcPublic from '../../../component/pc/index';

const BbsTip = () => {
  const [countdown] = useCountDown({
    targetDate: Date.now() + 10000,
    onEnd: PageJump.toHome,
  });

  return (
    <div className="bbs-tip">
      <PcPublic />
      <div className="bbs-content">
        <div className="tip-text">
          {Math.round(countdown / 1000)}
          秒后将自动跳转到希沃学苑平台
        </div>
        <div className="backhome-btn" onClick={PageJump.toHome}>
          去看看
        </div>
      </div>
    </div>
  );
};

export default bootstrap(BbsTip, { isMobile: false, wxShare: false });
